// extracted by mini-css-extract-plugin
export default {"button_main":"button_button_main__HUlpu"};